namespace GeniuzPOS.InitialData {
    export enum PsPosStationEumAutoChargeFg {
        AutoChargeFgNo = 0,
        AutoChargeFgYes = 1
    }
    Serenity.Decorators.registerEnumType(PsPosStationEumAutoChargeFg, 'GeniuzPOS.InitialData.PsPosStationEumAutoChargeFg');
}
